module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_black_24px.ad065df1.svg";